import { DropdownOption, SaveAsBatchEventNames } from '@app/pages/workspace/assign/configs/saveasbatch-table.config';
import { CarrierProvidersNames } from '@pdqdev/pdq-shared/dist/CarrierData';
import { Address, ShipmentCreationErrorCode } from '@pdqdev/pdq-shared/dist/entities';
import { IOrderRateDetails } from '@pdqdev/pdq-shared/dist/interfaces';

export const SERVICE_LEVEL_NAME_FIELD = 'serviceLevelName';
export const BOX_ID_NAME_FIELD = 'boxId';
export enum DeliveryTimeStatus {
  INTIME = 'intime',
  LATE = 'late',
  UNKNOWN = 'unknown',
  MIGHT_BE_LATE = 'might_be_late',
  FOR_PICKUP = 'for_pickup',
}

export const DELIVERY_TIME_STATUS_ORDER = {
  [DeliveryTimeStatus.LATE]: 0,
  [DeliveryTimeStatus.MIGHT_BE_LATE]: 1,
  [DeliveryTimeStatus.INTIME]: 2,
  [DeliveryTimeStatus.FOR_PICKUP]: 3,
  [DeliveryTimeStatus.UNKNOWN]: 4,
};

export const DEFAULT_SERVICE_LEVEL_NAME = 'Default';

export interface ProccessedSingleOrderRate {
  orderId: string;
  orderNumber: number;
  orderIsPickup: boolean;
  orderShipmentFee?: string;
  warningMessages?: {
    title?: string;
    text: string;
    code?: ShipmentCreationErrorCode;
    source?: CarrierProvidersNames;
  }[];
  errorMessages?: { title?: string; text: string }[];
  ratePrice?: string;
  orderPromiseDeliveryDate?: Date;
  estimationRateDeliveryDateStr?: string;
  estimationRateDeliveryDate?: Date;
  deliveryTimePredictionStatus: DeliveryTimeStatus;
  deliveryTimePredictionStatusPrint: string;
  etaFromPickupPrint?: string;
  sizeOptions?: DropdownOption[];
  boxName?: string;
  boxSize?: string;
  boxId?: number;
  serviceLevelOptions?: DropdownOption[];
  isShowMissingRatesIcon?: boolean;
  serviceLevelId: any;
  [SERVICE_LEVEL_NAME_FIELD]?: string;
  isDisabledForPurchasing: boolean;
  errors?: Array<string>;
  isLoadingRateData: boolean;
  isApiErrorResponce?: boolean;
  currentRateObject?: IOrderRateDetails;
  isSaturdayDelivery?: boolean;
  isShowSaturdayDeliveryCheckbox?: boolean;
  currentShippingAddress?: Address | null;
  isApiTimeOutCode?: boolean;
  isShouldTrySuggestedAddress?: boolean;
  isTriedSuggestedAddress?: boolean;
  isInternalRateCardPrice?: boolean;
  isMergedOrder?: boolean;
  itemCount?: number;
  skus: any;
  products?: any;
  id?: string;
  province?: string;
  nonRecommendedServiceLevel?: string;
  recommendedServiceLevelNames?: string[];
  isRecommendedServiceLevelExist?: boolean;
  recommendedServiceLevelNamesForDisplay?: string;
  switchedToSelectedRate?: string;
  originalRecommendedRate?: string;
}

export interface BatchRatesTableDropDownOnClickData {
  selectedOption: any;
  property: string;
  ordersIds: string[];
  rowToOptionMap?: Map<string, DropdownOption>;
}

export interface BatchRatesTableButtonEventData {
  ordersIds: string[];
  event: SaveAsBatchEventNames;
}
